import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import { StatusMessage } from '@hvcgroep/design-system';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { NodeEvent } from '../../../../types/nodes';

type Props = {
  entities: Immutable.List<ImmutableEntity<NodeEvent>>
};

const AllEvents = ({ entities }: Props) => {
  const { t } = useTranslation();

  if (entities.size === 0) {
    return (
      // @ts-expect-error
      <StatusMessage type="info">
        {t('views.no_results.events.all_1')}<br />
        {t('views.no_results.events.all_2')}
      </StatusMessage>
    );
  }

  return (
    <div className="AllEvents">
      {entities.map((entity, index) => {
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);

        return (
          <Node
            key={`${uuid}:${langcode}`}
            entity={entity}
            viewMode="teaser"
            flipped={index % 2 !== 0}
            withBackground
          />
        );
      })}
    </div>
  );
};

export default AllEvents;
